var moment = require('moment');

var utils = (function() {
    var _getId2Item = function(itemList){
        var id2Item = {};
        itemList.forEach(function(item){
            id2Item[item.id] = item;
        });
        return id2Item;
    }

    var _getLatestScore = function(scores){
        return scores[scores.length - 1] || {}
    }

    var _getLatestNonZeroScore = function(scores){
        var nonZeroScores = scores.filter(function(score){
            var isNonZero = false;
            score.data.forEach(function(scoreItem){
                if(scoreItem.percentile > 0){
                    isNonZero = true;
                }
            });
            return isNonZero;
        });

        return nonZeroScores[nonZeroScores.length - 1] || {};
    }

    var _getId2ItemScoresData = function(scores){
        var id2ItemScoresData = {};

        scores.forEach(function(score){
            score.data.forEach(function(scoreItem){
                if(scoreItem.percentile > 0){
                    id2ItemScoresData[scoreItem.item.id] = id2ItemScoresData[scoreItem.item.id] || {
                        id: scoreItem.item.id,
                        displayName: scoreItem.item.displayName,
                        scores: [],
                        timestamp2Score: {}
                    };
                    id2ItemScoresData[scoreItem.item.id].scores.push({
                        timestamp: score.timeStamp,
                        percentile: scoreItem.percentile
                    });
                    id2ItemScoresData[scoreItem.item.id].timestamp2Score[score.timeStamp] = scoreItem.percentile;
                }
            });
        });

        return id2ItemScoresData;
    }

    var _getScoresRelatedData = function(scores){
        // order scores by timeStamp ASC
        scores.sort(function(scoresA, scoresB){
            return moment(scoresA.timeStamp).isAfter(scoresB.timeStamp);
        });

        return {
            scores: scores,
            latestScore: _getLatestScore(scores),
            latestNonZeroScore: _getLatestNonZeroScore(scores),
            id2ItemScoresData: _getId2ItemScoresData(scores)
        }
    }

    return {
        getId2Item: _getId2Item,
        getScoresRelatedData: _getScoresRelatedData
    };

})();

module.exports = utils;


// WEBPACK FOOTER //
// ./src/common/modules/dashboard/utils.js